import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

export default function MagnifiedImage({ imageFileName, imageZoomFileName, imageAlt }) {
  const [open, setOpen] = useState(false);
  const titleId = `enlarged-image-${imageFileName.replace(/[^a-z0-9]+/gi, '-')}`;
  return <Box component="figure" sx={{ my: 3, mx: 0 }}>
    <img src={imageFileName} alt={imageAlt || ''} loading="lazy" style={{ maxWidth: '100%', height: 'auto' }} />
    <Box component="figcaption"><Button type="button" variant="text" onClick={() => setOpen(true)} aria-label={`Enlarge image: ${imageAlt || 'Lab illustration'}`}>Enlarge image</Button></Box>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth aria-labelledby={titleId}>
      <DialogTitle id={titleId} component="h2">Enlarged lab image</DialogTitle>
      <DialogContent tabIndex={0} sx={{ overflow: 'auto' }} aria-label="Image; scroll to explore details">
        <img src={imageZoomFileName || imageFileName} alt={imageAlt || ''} style={{ maxWidth: 'none' }} />
      </DialogContent>
      <DialogActions><Button autoFocus onClick={() => setOpen(false)}>Close</Button></DialogActions>
    </Dialog>
  </Box>;
}
